<template>
  <Modal
    v-model="isOpen"
    drawer
    class="KeepPlanModal"
    :title="t('ui.subscription.cancelPlan.keepPlan.success.title')"
    :titleIcon="{
      icon: 'check-circle',
      color: 'success'
    }"
  >
    <div class="KeepPlanModal-content">
      <p class="KeepPlanModal-description">
        {{ t('ui.subscription.cancelPlan.keepPlan.success.description') }}
      </p>
    </div>

    <template #actionPrimary>
      <ActionButton
        variant="primary"
        :size
        @click="close"
      >
        {{ t('ui.subscription.cancelPlan.keepPlan.success.action') }}
      </ActionButton>
    </template>
  </Modal>
</template>

<script setup lang="ts">
const { t } = useI18n();
const { isMobile } = useResponsive();
const size = computed(() => (isMobile.value ? 'sm' : 'md'));

const isOpen = defineModel<boolean>({ default: false });

function close() {
  isOpen.value = false;
}
</script>